import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MonopointCalculateMarginComponent } from './monopoint-calculate-margin/monopoint-calculate-margin.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { RouterModule } from '@angular/router';
import { MultipointCalculateMarginComponent } from './multipoint-calculate-margin/multipoint-calculate-margin.component';

const exportComponents = [
  MonopointCalculateMarginComponent,
  MultipointCalculateMarginComponent
];
@NgModule({
  declarations: [...exportComponents],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: exportComponents,
  schemas: [NO_ERRORS_SCHEMA],
})
export class SharedModule { }
